import isEmpty from "is-empty";
import PropTypes from "prop-types";
import React from "react";
import { Property } from "rsl-api-106/lib/types";

import Button from "@components/_Layout/Controls/Button";
import ButtonAddToFavorites from "@components/Favorites/ButtonAddToFavorites";
import PropertyPopup from "@components/Property/PropertyPopup";
import { useSession } from "@hooks";
import { replaceImgOnError } from "@utils/dom";
import { showFavoritesEtab } from "@utils/favorites";

type EtabBlockProps = {
  etab: Property;
};

const languagesVarsCodes = [
  "LANG_neobooking_more_details", //Plus de détails
];

const EtabBlock: React.FC<EtabBlockProps> = ({ etab }) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <div className="tw-grid tw-grid-cols-12 tw-border-b">
      <div className="tw-col-span-12 sm:tw-col-span-8 lg:tw-col-span-9 tw-bg-gray-50 tw-order-2 sm:tw-order-1">
        <div className="tw-h-full tw-p-2 tw-flex tw-flex-col tw-justify-between">
          <div>
            <div className="tw-mb-3">
              <div className="tw-flex tw-items-center tw-justify-between">
                <div className="tw-font-semibold tw-text-lg">{etab.label}</div>
                {showFavoritesEtab() && (
                  <ButtonAddToFavorites mode="etab" etabId={etab.id!!} />
                )}
              </div>
              <div className="tw-text-sm tw-italic">
                <p className="tw-lowercase first-letter:tw-capitalize tw-inline-block">
                  {!isEmpty(etab.address?.city) && (
                    <>
                      {etab.address?.city}
                      {!isEmpty(etab.address?.zipCode) && (
                        <>
                          {` `}({etab.address?.zipCode})
                        </>
                      )}
                    </>
                  )}
                </p>
                {!isEmpty(etab.address?.addressCountry?.code) && (
                  <>
                    <span className="tw-mx-1">/</span>
                    <p className="tw-lowercase first-letter:tw-capitalize tw-inline-block">
                      {etab.address?.addressCountry?.label}
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className="tw-w-4/5">
              <div
                className="tw-mb-2 tw-leading-5"
                dangerouslySetInnerHTML={{ __html: etab.description!! }}
              ></div>
              {/*
                (cms && Array.isArray(cms) && cms.length >= 1) &&
                <>
                  <span>Points forts</span>
                  <ul className="list-disc list-inside text-sm columns-2">
                    {cms.map((item, index) => {
                      return <li key={`cms_${index}_${item.code}`}>{item.value}</li>;
                    })}
                  </ul>
                </>
              */}
            </div>
          </div>
          <div className="tw-flex tw-justify-end">
            <PropertyPopup
              btnElement={(onClick) => (
                <Button shape="link" onClick={onClick}>
                  {getLanguageVarValue("LANG_neobooking_more_details")}
                </Button>
              )}
              property={etab}
            />
          </div>
        </div>
      </div>
      <div className="tw-col-span-12 sm:tw-col-span-4 lg:tw-col-span-3 tw-order-1 sm:tw-order-2">
        <div className="tw-overflow-hidden tw-w-full tw-h-full">
          <img
            className="tw-w-full tw-h-full tw-object-cover hover:tw-scale-105 tw-transition-all tw-duration-200 tw-ease-in-out"
            src={etab.imagePath ?? ""}
            onError={(e) => replaceImgOnError(e)}
            style={{ maxHeight: "250px" }}
          />
        </div>
      </div>
    </div>
  );
};

EtabBlock.propTypes = {
  //
};

export default EtabBlock;
